import {
  origamisByUsername,
  deleteOrigami,
  getOrigamiEdit,
} from '../../graphql/graphql';
import { fetchItemsNextToken } from '../../graphql/query-helpers';
import { client } from '../../amplify';

export const boxService = {
  load,
  deleteOG,
  editOG,
};

// Only the newest scan is needed to put a model on screen, and a 1000-row page
// took 1.1-2.1 s to come back. A small first page gets the first model started
// sooner; everything after it still comes in 1000-row pages.
const FIRST_PAGE = 50;
const LATER_PAGES = 1000;

async function load(username, onPage) {
  const qparams = {
    username: username,
    limit: FIRST_PAGE,
    sortDirection: 'DESC',
  };

  return fetchItemsNextToken({
    query: origamisByUsername,
    variables: qparams,
    nextLimit: LATER_PAGES,
    // Fires once per page as it lands; the action layer streams each one
    // into the store rather than waiting for the whole set.
    callback: onPage,
  });
}

async function deleteOG(id) {
  return client.graphql({ query: deleteOrigami, variables: { id: id } });
}

// Retrieves DB info and photo to put into maker
async function editOG(id) {
  return client.graphql({ query: getOrigamiEdit, variables: { id: id } });
}
